<template>
    <div class="library">
        <Header />
        <div class="library-container">
            <h2 class="title">Biblioteca Unimais</h2>
            <p class="subtitle">Pesquise por temas, trechos, palavras-chave, e encontre o seu material.📚</p>
            <Search @filtro-atualizado="atualizarFiltro" />
            <!-- Lista de livros (cards) -->
            <div class="pdf-grid">
                <CardDiscipline v-for="pdf in filteredPdfs" :key="pdf.codigo_disciplina" :discipline="pdf" />
                <div v-if="filteredPdfs.length === 0" class="no-results">
                    Nenhum Livro encontrado.
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import '../styles/Library.css';
import Header from '../components/Header.vue';
import CardDiscipline from '../components/CardDiscipline.vue';
import request from '../router/request';
import Search from '../components/Search.vue';
import token from '../scripts/token';

export default {
    name: 'LibraryView',
    components: {
        Header,
        CardDiscipline,
        Search,
    },
    data() {
        return {
            search: '',
            filtroArea: '',
            listaArea: [],
            pdfs: [],
            selectedBook: null,
            objetoVisualizar: {},
            viewDoc: '',
            pdfLista: [],
            currentPDF: 0,
            showModal: false,
            loading: false,
        };
    },
    methods: {
        atualizarFiltro(filtro) {
            this.search = filtro.texto; // Atualiza a propriedade search
            this.filtroArea = filtro.area; // Atualiza a nova propriedade filtroArea para a área
        }
    },
    computed: {
        filteredPdfs() {
            if (!Array.isArray(this.pdfs)) return [];
            return this.pdfs.filter(pdf => {
                const nomeMatch = !this.search || pdf.nome_disciplina.toLowerCase().includes(this.search.toLowerCase());

                // AQUI ESTÁ O AJUSTE CRÍTICO:
                // Compara o codigo_grupo do PDF (que vem do SELECT) com o filtroArea (o codigo_grupo selecionado no dropdown)
                const areaMatch = !this.filtroArea || pdf.codigo_grupo == this.filtroArea;

                return nomeMatch && areaMatch;
            });
        }
    },
    mounted() {
        window.scrollTo(0, 0);
        token.validarToken();
        token.startTokenRefreshInterval();

        // Carregar livros
        request.post('ava/listarBiblVirtual')
            .then(response => {
                const resultado = response.data;
                
                if (Array.isArray(resultado)) {
                    this.pdfs = resultado;
                } else if (Array.isArray(resultado.data)) {
                    this.pdfs = resultado.data;
                } else {
                    console.warn('Resposta inesperada para listarBiblVirtual:', resultado);
                    this.pdfs = [];
                }
            })
            .catch(err => {
                console.error('Erro ao carregar livros:', err);
                this.pdfs = [];
            })
            .finally(() => {
                this.loading = false;
            });
    }
};
</script>
